import React from 'react';
import { SaveInspectionForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveInspectionModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveInspectionModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save inspection'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveInspectionForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        milestoneId={params.milestoneId ?? undefined}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
